import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Delete = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement(SvgFill, {
    d: "m8.67 16.44 2.098 26.081c0 .1.1.2.2.2h18.487v-.1l2.199-26.182c0-.1-.1-.2-.2-.2H8.87c-.1 0-.2.1-.2.2Zm-1.799.1c-.1-1.1.8-2.1 1.999-2.1h22.684c1.099 0 1.998 1 1.898 2.1L31.354 42.62c-.1 1-.9 1.799-1.899 1.799H10.968c-1 0-1.899-.8-1.899-1.799L6.871 16.54ZM35.55 6.047l-8.293-1.2.2-1.398v-.3c0-1-.7-1.799-1.7-1.899l-5.495-.8c-1.1-.2-2.099.6-2.199 1.6l-.2 1.399-8.494-1.2c-1.099-.2-2.098.6-2.198 1.6l-.4 2.498c-.2 1.099.6 2.098 1.599 2.198l26.282 3.897h.3c.999 0 1.798-.7 1.898-1.699l.4-2.498c.1-1.099-.7-2.098-1.7-2.198ZM19.763 2.349s0-.1.1-.1h.1l5.496.8s.1 0 .1.1v.1l-.2 1.299-5.796-.9.2-1.299Zm15.689 5.597-.4 2.498c0 .1-.1.2-.2.1L8.67 6.746s-.1 0-.1-.1v-.1l.4-2.498s0-.1.1-.1h.1L35.35 7.746s.1 0 .1.1v.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M13.566 21.636c.5 0 .9.3 1 .8l1.099 13.69c0 .5-.3.9-.8.999-.5 0-.899-.3-.999-.8l-1.1-13.69c0-.5.3-.9.8-1ZM26.757 21.636c.5 0 .9.5.8 1l-1.1 13.69c0 .5-.5.899-.999.799-.5 0-.9-.5-.8-1l1.1-13.69c.1-.4.5-.8.999-.8Z"
  })));
});
Delete.displayName = 'Delete';
Delete.defaultProps = {
  'aria-label': 'Delete'
};
export default Delete;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Delete.js
// module id = 3769
// module chunks = 11